document.addEventListener("DOMContentLoaded", function() {
  const container = document.getElementById("wp-latest-posts");
  if (!container) return;

  fetch("https://あなたのWordPressサイト.com/wp-json/wp/v2/posts?per_page=5")
    .then(response => response.json())
    .then(posts => {
      let html = "<ul>";
      posts.forEach(post => {
        html += `<li>
                   <a href="${post.link}" target="_blank">${post.title.rendered}</a>
                   <p>${post.excerpt.rendered}</p>
                 </li>`;
      });
      html += "</ul>";
      container.innerHTML = html;
    })
    .catch(err => console.error("WordPress記事取得エラー:", err));
});

